import { useMemo } from 'react';
import { useAddEvaluationGradeEntry } from '../../../Loaders/AddEvaluationGradeEntryLoader';
import { DeliveryModes } from '../../../types';

const useOnlineDeliveryModeToGradesView = () => {
  const { data } = useAddEvaluationGradeEntry();
  const deliveryMode = data?.StructureTypeSchema_deliveryMode;

  const isOnlineDeliveryMode = useMemo(() => {
    return (
      !!deliveryMode &&
      [DeliveryModes.OL, DeliveryModes.SP, DeliveryModes.OA].includes(
        deliveryMode as DeliveryModes,
      )
    );
  }, [deliveryMode]);

  return {
    isOnlineDeliveryMode,
  };
};

export default useOnlineDeliveryModeToGradesView;
